const RtlActionTypes = {
  CHANGE_DIRECTION_TO_LTR: 'CHANGE_DIRECTION_TO_LTR',
  CHANGE_DIRECTION_TO_RTL: 'CHANGE_DIRECTION_TO_RTL',
};

export default RtlActionTypes;
